import { FreeHtmlTextSectionView } from "@cma/presentation-generation-logic/models/section-view";
import { AIAssistedTextSectionView } from "@cma/presentation-generation-logic/sections/ai-assisted-text/ai-assisted-text-section-view";
import { useContentHydration } from "./useContentHydration";
import { PresentationSectionViewProps } from "../PresentationSectionProps";
import { PrintPaper, PrintPage } from "../../shared/Print.styles";
import {
  FreeTextHtmlContent,
  TextContentContainer,
} from "./FreeHtmlText.styles";

interface Props
  extends PresentationSectionViewProps<
    FreeHtmlTextSectionView | AIAssistedTextSectionView
  > {}

export const FreeHtmlTextPrint = (props: Props) => {
  const {
    sectionView: { htmlContent },
  } = props;
  const { contentRef } = useContentHydration([htmlContent]);

  return (
    <PrintPaper>
      <PrintPage>
        <TextContentContainer>
          <FreeTextHtmlContent
            ref={contentRef}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        </TextContentContainer>
      </PrintPage>
    </PrintPaper>
  );
};
